import { FooterButtonContainer, FooterFixedRoot } from '@ifca-ui/core/src/components/Footer/Footer';
import AppContext, { AppContextProps } from 'containers/context/Context';
import {tabs} from "./CommissionCalculationListing.json";
import { 
    useState , 
    useEffect, 
    useContext,
    useCallback
} from "react";
import useNav from 'components/RouteService/useNav';
import { treeItemClasses, 
    TreeView, 
    TreeItem, 
} from '@mui/lab/';
import moment from 'moment';
import { 
    SubContainerX,
    FooterButton,
    Container,
    Card,
    Tabs,
    Tab,
} from "@ifca-ui/core";
import { 
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    CheckBox as CheckBoxIcon,
    IndeterminateCheckBox as IndeterminateCheckBoxIcon,
    CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankIcon,
} from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';
import {CommissionItemList, CompanyRewardList} from "./CommissionCalculationListing.json";
import { IconButton, Typography, Box , TextField} from '@mui/material';
import {
    useGetCommissionCalculationDetailDataLazyQuery,
    useGetCompanyRewardDetailDataLazyQuery
  } from 'generated/graphql';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CommonYupValidation } from 'helpers/yup';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';

export const CommissionCalculationDetail = () => {
    const { rootState, rootDispatch } = useContext<AppContextProps>(AppContext)
    const location = useLocation()
    const { projectID, data, detailDate, tabIndexData } = location.state.state||{};
    const [tabIndex, setTabIndex] = useState(tabIndexData??0)
    const { navTo } = useNav()
    const [CommmissionCalculationList, setCommissionCalculationList]   = useState<CommissionCalculationProps[]>([]); 
    const [CommissionItemListData, setCommissionItemList] = useState<CommissionCalculationProps[]>([]);
    interface DetailCommissionProps {
        id: number;
        date: string;
        description: string;
        netSales: number;
        commissionAmount: number;
    }
    interface CommissionCalculationProps {
        parent_id: string;
        principal?: string;
        employee_unit?: string;
        generate_date?: Date;
        employee_id?: string;
        net_selling?: number;
        total_selling?: number;
        sales_commission?: number;
        commission_type?: string;
        total_net_selling?: number;
        total_commission?: string;
        type?: string;
        children: CommissionCalculationDetail[]
    }
    interface CommissionCalculationDetail {
        detail_id?: string;
        project_commission_calc_id?: string;
        doc_no?: string;
        doc_date?: string;
        sale_id?: string;
        net_selling?: number;
        commission_amt?: number;
        commission_type?: string;
        type: string;
        children: CommissionCalculationChild[];
    }
    interface CommissionCalculationChild{
        child_id?: string;
        project_commission_calc_id?: string;
        doc_no?: string;
        doc_date?: string;
        sale_id?: string;
        net_selling?: number;
        commission_amt?: number;
        commission_type?: string;
        type: string;
    }
    interface CompanyRewardProps {
        parent_id: string;
        principal?: string;
        employee_unit?: string;
        generate_date?: Date;
        employee_id?: string;
        net_selling?: number;
        total_selling?: number;
        sales_commission?: number;
        commission_type?: string;
        total_net_selling?: number;
        total_commission?: string;
        type?: string;
        children: CompanyRewardDetail[]
    }
    interface CompanyRewardDetail {
        detail_id?: string;
        company_commission_calc_id?: string;
        doc_no?: string;
        doc_date?: string;
        sale_id?: string;
        net_selling?: number;
        commission_amt?: number;
        commission_type?: string;
        type: string;
        children: CompanyRewardChild[];
    }
    interface CompanyRewardChild{
        child_id?: string;
        company_commission_calc_id?: string;
        doc_no?: string;
        doc_date?: string;
        sale_id?: string;
        net_selling?: number;
        commission_amt?: number;
        commission_type?: string;
        type: string;
    }
    const memberSchema = yup.object().shape({
        date: CommonYupValidation.requireField(SystemMsgs.date())
    })
    const [CompanyRewardOptions, setCompanyRewardOptions] = useState<CompanyRewardProps[]>([]);
    const [CompanyRewardData, setCompanyRewardData] = useState<CompanyRewardProps[]>([]);
    const [getData, {loading: loading2}] = useGetCommissionCalculationDetailDataLazyQuery({
        variables:{
            inputDate: detailDate,
            projectId: projectID
        },
        onCompleted: (data)=>{
            setCommissionCalculationList(data.getCommissionCalculationDetailData);
        }
    })
    const [getCompanyRewardListing] = useGetCompanyRewardDetailDataLazyQuery({
        variables:{
            inputDate: detailDate
        },
        onCompleted(data) {
        if(!data.getCompanyRewardDetailData) return;
        var newdata = [...data.getCompanyRewardDetailData]
        newdata = newdata.map((item: any) => ({
            ...item,
        }));
        setCompanyRewardOptions(newdata);
    }})
    useEffect(()=>{
        let loaded = true;
        if (tabIndex===0){
            getData();
        }else {
            getCompanyRewardListing();
        }
        return ()=>{
            loaded = false;
        }
    },[])
    useEffect(()=>{
        let loaded = true;
        if (tabIndex===0){
            getData();
        }else {
            getCompanyRewardListing();
        }
        return ()=>{
            loaded = false;
        }
    },[tabIndex])
    useEffect(() => {
        let totalNetSales = 0;
        let totalCommission = 0;
        if (CompanyRewardOptions.length>0){
            const newNode: any[]=[];
            const transform = CompanyRewardOptions.map((item: CommissionCalculationProps, index, array) => {
                const newParentData = uuidv4();
                const newDisplay = item.children.map((detail)=>{
                totalNetSales+=detail.net_selling;
                const newDetailData = uuidv4();
                const newChild = detail.children.map((child)=>{
                        totalCommission+=child.commission_amt;
                        return {
                            ...child,
                            doc_date: child.doc_date,
                            child_id: uuidv4(),
                            company_commission_calc_id: newDetailData,
                        }
                    })
                    return {
                        ...detail,
                        detail_id: newDetailData,
                        company_commission_calc_id: newParentData,
                        children: newChild,
                    }
                })
                return {
                    ...item,
                    parent_id: newParentData,
                    children: newDisplay,
                }
            });
            setCompanyRewardData(transform);
        } 
        setValue('netSales', totalNetSales);
        setValue('commissionAmount', totalCommission);
    },[CompanyRewardOptions]);
    useEffect(() => {
        let totalNetSales = 0;
        let totalCommission = 0;
        if (CommmissionCalculationList.length>0){
            const newNode: any[]=[];
            const transform = CommmissionCalculationList.map((item: CommissionCalculationProps, index, array) => {
                const newParentData = uuidv4();
                const newDisplay = item.children.map((detail)=>{
                    totalNetSales+= detail.net_selling;
                    const newDetailData = uuidv4();
                    const newChild = detail.children.map((child)=>{
                        totalCommission+= child.commission_amt;
                        return {
                            ...child,
                            doc_date: child.doc_date,
                            child_id: uuidv4(),
                            project_commission_calc_id: newDetailData,
                        }
                    })
                    return {
                        ...detail,
                        detail_id: newDetailData,
                        project_commission_calc_id: newParentData,
                        children: newChild,
                    }
                })
                return {
                    ...item,
                    parent_id: newParentData,
                    children: newDisplay,
                }
            });
            setCommissionItemList(transform);
        }
        setValue('netSales', totalNetSales);
        setValue('commissionAmount', totalCommission);
    },[CommmissionCalculationList])
    const {
        handleSubmit: handleSubmit,
        register: register,
        control: control,
        setValue: setValue,
        getValues: getValues,
        watch: watch,
        reset: reset,
        clearErrors: clearErrors,
        setError: setError,
        formState: { errors:errors, isSubmitted:isSubmitted },
      } = useForm<DetailCommissionProps>({
        defaultValues: {
          id: null,
          date: data.date??"",
          description: data.description??"",
          netSales: 0,
          commissionAmount: 0,
        },
        mode: 'onSubmit',
        resolver: yupResolver(memberSchema),
      })
    useEffect(()=>{
        rootDispatch({
            type: 'headerComponent',
            payload: {
                ...rootState.headerComponent,
                leftIcon: {
                    icon: 'back',
                    props: {
                        onClick: () => {
                            navTo(`/sales-commission/${projectID}/commission-calculation`,{
                                state:{projectID, tabIndexData: tabIndex}
                            });
                        },
                    },
                },
                bottomSection: {
                    breadcrumbs: {
                        current: `Commission Calculation`,
                        maxItems: 1,
                    },
                },
            }
        })
    },[]);
    const [expanded, setExpanded] = useState<string[]>([]);
    const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
        setExpanded(nodeIds);
    };
    const handleExpandClick = (event: React.MouseEvent, nodeId: string) => {
        event.stopPropagation();
        setExpanded((prevExpanded) =>
            prevExpanded.includes(nodeId)
            ? prevExpanded.filter((id) => id !== nodeId)
            : [...prevExpanded, nodeId] 
        );
    };
    const [checkedItems, setCheckedItems] = useState<string[]>([]);
    const updateParentCommission = (nodeId: string, updatedCheckedItems: string[]) => {
        const findParent = (id: string, nodes: any[], parent: any = null): any => {
            for (const node of nodes) {
                if (node.id === id) return parent;
                if (node.children) {
                    const result = findParent(id, node.children, node);
                    if (result) return result;
                }
            }
            return null;
        };
    
        let currentId = nodeId;
        while (true) {
            const parent = findParent(currentId, CommissionItemListData);
            if (!parent || !parent.children) break;
    
            let newSalesCommission = 0;
            parent.children.forEach((child: any) => {
                if (updatedCheckedItems.includes(child.id)) {
                    const sc = parseFloat(child.salesCommission?.replace(/,/g, '') || '0');
                    const amount = parseFloat(child.amount?.replace(/,/g, '') || '0');
                    newSalesCommission += sc + amount;
                }
            });
    
            parent.salesCommission = newSalesCommission.toString(); 
            currentId = parent.id;
        }
    };
    const toggleCheck = (nodeId: string) => {
        const node = findNodeById(nodeId);
        if (!node) return;

        const nodeCheckState = getNodeCheckState(nodeId); 
        const isCurrentlyChecked = nodeCheckState === 'checked'|| nodeCheckState === 'indeterminate'; 

        let updatedCheckedItems = [...checkedItems];
        const allNodeIds = collectAllNodeIdsIncludingSelf(node);

        let totalNetSales = getValues('netSales') || 0;
        let totalCommission = getValues('commissionAmount') || 0;

        allNodeIds.forEach(id => {
            const childNode = findNodeById(id);
            if (!childNode) return;
    
            const netSelling = parseFloat(childNode.netSelling?.replace(/,/g, '') || '0');
            const currentNetSelling = parseFloat(childNode.netSelling?.replace(/,/g, '') || '0');
            const salesCommission = parseFloat(childNode.salesCommission?.replace(/,/g, '') || '0');
            const amount = parseFloat(childNode.amount?.replace(/,/g, '') || '0');
            const isChecked = updatedCheckedItems.includes(id);

            if (isCurrentlyChecked) {
                if (isChecked){
                    updatedCheckedItems = updatedCheckedItems.filter(item => item !== id);
                    totalNetSales = Math.max(0, totalNetSales- netSelling);
                    totalCommission = Math.max(0, totalCommission - amount);
                }
            } else {
                if (!isChecked) {
                    updatedCheckedItems.push(id);
                    totalNetSales += netSelling;
                    totalCommission += salesCommission+amount;                    
                }
            }
        });

        updatedCheckedItems = syncParentCheckStates(nodeId, updatedCheckedItems);
        updateParentCommission(nodeId, updatedCheckedItems);
        
        setCheckedItems(updatedCheckedItems);
        setValue('netSales', totalNetSales);
        setValue('commissionAmount', totalCommission);
    
        return updatedCheckedItems;
    };
    const findNodeById = (id: string) => {
        const search = (nodes: any[]): any => {
            for (const node of nodes) {
            if (node.id === id) return node;
            if (node.children) {
                const childResult = search(node.children);
                if (childResult) return childResult;
            }
            }
            return null;
        };
        
        return search(CommissionItemListData); 
    };  
    const collectAllDescendantIds = (n: any): string[] => {
        let ids: string[] = [n.id];
        if (n.children) {
            n.children.forEach((child: any) => {
                ids.push(child.id);
                ids = ids.concat(collectAllDescendantIds(child));
            });
        }
        return ids;
    };
    const collectAllNodeIdsIncludingSelf = (node: any): string[] => {
        return [node.id].concat(collectAllDescendantIds(node));
    };
    const syncParentCheckStates = (nodeId: string, updatedChecked: string[]): string[] => {
        const findParent = (id: string, nodes: any[], parent: any = null): any => {
            for (const node of nodes) {
            if (node.id === id) return parent;
            if (node.children) {
                const result = findParent(id, node.children, node);
                if (result) return result;
            }
            }
            return null;
        };
        
        let currentId = nodeId;
        while (true) {
            const parent = findParent(currentId, CommissionItemListData);
            if (!parent) break;
        
            const allChildIds = collectAllDescendantIds(parent);
            const directChildIds = parent.children?.map((c: any) => c.id) || [];
        
            const allChildrenChecked = directChildIds.every(id => updatedChecked.includes(id));
            if (allChildrenChecked) {
            if (!updatedChecked.includes(parent.id)) {
                updatedChecked.push(parent.id);
            }
            } else {
            updatedChecked = updatedChecked.filter(id => id !== parent.id);
            }
        
            currentId = parent.id;
        }
        
        return updatedChecked;
    };
        
    const getNodeCheckState = useCallback((nodeId: string): 'checked' | 'indeterminate' | 'unchecked' => {
        const node = findNodeById(nodeId);
        if (!node) return 'unchecked';
    
    
        const allIds = collectAllDescendantIds(node);
        
        if (allIds.length===0){
            return checkedItems.includes(nodeId) ? 'checked' : 'unchecked';
        }
        const checkedCount = allIds.filter(id => checkedItems.includes(id)).length;
        if (checkedCount === allIds.length) 
            return checkedItems.includes(nodeId) ? 'checked' : 'indeterminate';

        if (checkedCount > 0) return 'indeterminate';
        return 'unchecked';
    },[checkedItems]);

    function thousandSeparator(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }

    function dateSeparator(dateString) {
        if (!dateString) return
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(date); 
    }

    function monthSeparator(dateString) {
        if (!dateString) return
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', {
            month: 'short',
            year: 'numeric'
        }).format(date); 
    }
    return (
        <>
            <SubContainerX>
                <Box display="flex">
                    <Box width={'100%'}>
                        <Tabs
                            className="bill-item-tabs"
                            value={tabIndex}
                            onChange={(e, v) => setTabIndex(v)}
                            variant="fullWidth"
                            centered
                            style={{ width: '100%' }}
                        >
                            {tabs.map((tab, i) => (
                                <Tab
                                    key={i}
                                    value={i}
                                    style={ { flexGrow: 1, maxWidth: '100%'}}
                                    label={
                                    <Typography className="text-mdLabel">{tab.label}</Typography>
                                    }
                                />
                            ))}    
                        </Tabs>
                    </Box>
                </Box>
            </SubContainerX>
            <Box sx={{display:"block", my:2}}>
                <TreeView
                    expanded={expanded}
                    onNodeToggle={handleToggle}
                    sx={{
                        width: '100%',
                        marginBottom: '180px',
                        [`& .${treeItemClasses.selected}`]: {
                            background: 'inherit !important', 
                            color: 'inherit !important', 
                        },
                        [`& .${treeItemClasses.focused}`]: {
                            background: 'inherit !important',
                        },
                        [`& .MuiTreeItem-content`]: {
                            paddingLeft: 0,
                            marginLeft:-1,
                        }
                        }}
                >
                    {(tabIndex===0?CommissionItemListData:CompanyRewardData)?.map((node, nodeIndex) => (
                        <TreeItem 
                            key={node.parent_id}
                            label={
                                <Box 
                                    sx={{
                                        display: "flex", 
                                        justifyContent: "space-between",
                                        background: 'white',
                                        mb: 1,
                                        width: '100%',
                                        borderRadius: '4px',
                                        pr: 2
                                    }}
                                    onClick={(e) => handleExpandClick(e, node.parent_id)}
                                >
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleExpandClick(e, node.parent_id);
                                    }}
                                >
                                    {expanded.includes(node.parent_id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                                <Box
                                    sx={{
                                    padding: "4px 8px",
                                    display: "block",
                                    justifyContent:"space-between",
                                    paddingTop: 1, 
                                    paddingBottom: 1,
                                    cursor: "pointer",
                                    width:"100%",
                                    mr: -1,
                                    "&:hover": { backgroundColor: "inherit" },
                                    }}
                                >
                                    <Typography className='text-xsTitle' sx={{fontWeight:"bold !important"}}>{node.principal}</Typography>
                                    <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                    <Typography className='text-desc'>{node.job_position}</Typography>
                                    <Typography className='text-desc'>{node.employee_name}</Typography>
                                    </Box>
                                    <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                        <Typography className='text-desc'>Net Selling:</Typography>
                                        <Typography className='text-desc' color="primary">{thousandSeparator(node.total_selling)}</Typography>
                                    </Box>
                                    <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                        <Typography className='text-desc'>{tabIndex===0?'Sales Commission':'Company Reward'}:</Typography>
                                        <Typography className='text-desc' color="primary">{thousandSeparator(node.total_commission)}</Typography>
                                    </Box>
                                </Box>
                                
                                </Box>
                            }
                            sx={{
                                "&.Mui-focused, & .MuiTreeItem-content.Mui-focused, & .MuiTreeItem-content.Mui-selected, & .MuiTreeItem-content:hover": {
                                    backgroundColor: "inherit !important",
                                    color: "inherit !important",
                                },
                                "& .MuiTreeItem-content.Mui-expanded": {
                                    backgroundColor: "inherit !important",
                                    color: "inherit !important",
                                },
                                '& .MuiTreeItem-content': {
                                    paddingRight: '0px !important',
                                    paddingLeft: '0px !important',
                                },
                                "&.MuiTreeItem-root": {
                                    paddingLeft: 0,
                                    marginLeft: '-4px',
                                },
                                '& .MuiTreeItem-label': {
                                    paddingLeft: '0 !important',
                                    paddingRight: '0 !important',
                                },
                                '& .MuiTreeItem-group': {
                                    marginLeft: 0,
                                    marginRight: 0,
                                },
                            }} 
                            nodeId={node.parent_id}
                            >
                            {(node.children)?.map((child, childIndex) => (
                            <TreeItem
                                key={child.id}
                                nodeId={String(child.detail_id)}
                                label={
                                    <Box sx={{display: "flex", 
                                        justifyContent: "space-between", 
                                        width:"auto",
                                        background: 'white',
                                        mb: 1,
                                        borderRadius: '4px',
                                        mx: 2,
                                        pr:'9px',
                                        }}>
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleExpandClick(e, child.detail_id);
                                            }}
                                        >
                                            {expanded.includes(child.detail_id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                        <Box sx={{display:"flex", justifyContent:"space-between", width:"100%", mr:1, my: 1}}>
                                            <Box sx={{width:"100%"}}>
                                            <Typography className='text-desc' 
                                                sx={{paddingTop: 0, 
                                                paddingBottom: 0, fontWeight:"600 !important"}}>
                                                {child.unit_no ?? ''}
                                            </Typography>
                                            <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                    <Typography className='text-desc'>{dateSeparator(tabIndex===0?child.generate_date:child.doc_date)}</Typography>
                                                    <Typography className='text-desc'>{tabIndex===0?child.employee_name:child.sales_registration_no}</Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                <Typography className='text-desc'>Net Selling:</Typography>
                                                <Typography className='text-desc' color="primary">{thousandSeparator(child.net_selling)}</Typography>
                                            </Box>
                                            <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                <Typography className='text-desc'>{tabIndex===0?'Sales Commission':'Company Reward'}:</Typography>
                                                <Typography className='text-desc' color="primary">{thousandSeparator(child.commission_amt)}</Typography>
                                            </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                }
                                sx={{
                                    "& .MuiTreeItem-content.Mui-focused": {
                                    backgroundColor: "transparent !important",
                                    },
                                    "& .MuiTreeItem-content.Mui-selected": {
                                    backgroundColor: "transparent !important",
                                    },
                                    "& .MuiTreeItem-content:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                                    },
                                    "&.Mui-focused, & .MuiTreeItem-content.Mui-focused, & .MuiTreeItem-content.Mui-selected, & .MuiTreeItem-content:hover": {
                                    backgroundColor: "inherit !important",
                                    color: "inherit !important",
                                    },
                                    "& .MuiTreeItem-content.Mui-expanded": {
                                    backgroundColor: "inherit !important",
                                    color: "inherit !important",
                                    },
                                }}
                            >
                                {child?.children?.map((subChild, subChildIndex) => (
                                <TreeItem key={subChildIndex} nodeId={subChild.child_id} 
                                    label={
                                        <>
                                        <Box sx={{
                                            display:"flex", 
                                            width:"auto", 
                                            justifyContent:"space-between", 
                                            alignItems:"center", 
                                            backgroundColor:"#f0efed",
                                            pr:'9px',
                                            borderRadius: '4px',
                                            mb: 1,
                                            mx:4
                                            }} 
                                            key={subChildIndex}
                                        >
                                            <Box sx={{width:"100%", display:'flex', pb:1}}>
                                                <Box sx={{px:1, alignItems:"center", display:"flex"}}>
                                                <b>•</b>
                                                </Box>
                                                <Box sx={{my: 1, mr: 1, width: "100%"}}>
                                                    <Typography key={subChildIndex} variant="body1" 
                                                    sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight:"500 !important" }} 
                                                    className="text-desc">
                                                        {subChild.commission_type}
                                                    </Typography>
                                                    <Typography className='text-desc'>{monthSeparator(subChild.doc_date)}</Typography>
                                                    <Box sx={{display:"flex", justifyContent:"space-between", width:"100%"}}>
                                                        <Typography className='text-desc'>Amount:</Typography>
                                                        <Typography className='text-desc' color="primary">{thousandSeparator(subChild.commission_amt)}</Typography>
                                                    </Box>
                                                
                                                </Box>
                                            
                                            </Box>
                                            {/* <IconButton onClick={e => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                toggleCheck(subChild.id);
                                                }}>
                                                {{
                                                    checked: <CheckBoxIcon style={{ color: '#ff9900' }} />,
                                                    indeterminate: <IndeterminateCheckBoxIcon style={{ color: '#ff9900' }} />,
                                                    unchecked: <CheckBoxOutlineBlankIcon style={{ color: '#212121' }} />,
                                                }[getNodeCheckState(subChild.id)]}            
                                            </IconButton> */}
                                        </Box>
                                        </>
                                    }
                                    sx={{[`& .${treeItemClasses.group}`]: {
                                        marginLeft: '14.5px !important',
                                        paddingLeft: '12px !important',
                                        borderLeft: '0px !important',
                                    }}}
                                >
                                    
                                </TreeItem>
                                ))}
                            </TreeItem>  
                            ))}
                        </TreeItem> 
                    ))}
                </TreeView>
            </Box>
            <FooterFixedRoot width={1} display={"flex"} justifyContent={"center"} gap={'10%'}>
            <Box width={"100%"} sx={{justifyContent:"center"}}>
            <Box width={1} sx={{display:"block",mb:1}}>
                <Box
                    sx={{
                    backgroundColor: '#FFA500',
                    color: 'white',
                    padding: '16px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                    marginBottom: '0px',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography className="text-desc" fontWeight="bold">Net Selling Price:</Typography>
                    <Typography className="text-desc" fontWeight="bold">{getValues('netSales').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography className="text-desc" fontWeight="bold">{tabIndex===0?'Commission Amt:':'Reward Amt:'}</Typography>
                    <Typography className="text-desc" fontWeight="bold">{getValues('commissionAmount').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                    display: 'none', 
                    justifyContent: 'center', 
                    width:'100%', 
                    gap: 1,
                    }}>

                    <FooterButtonContainer>
                        <FooterButton 
                            variant="contained" 
                            disabled={!true}
                            sx={{
                                backgroundColor: !false ?'#A9A9A9 !important':'primary.main',
                                color: 'white !important',
                                margin: '8px 18px 8px 9px',
                                alignItems:"bottom",
                                padding:"10px 100px"
                            }}
                            onClick={()=>{
                                navTo(`/sales-commission/${projectID}/commission-calculation`,{
                                state:{projectID, tabIndexData: tabIndex}
                                });
                            }}
                        >
                            Cancel
                        </FooterButton>
                    </FooterButtonContainer>
                    <FooterButtonContainer>
                        <FooterButton 
                        variant="contained" 
                        disabled={!true}
                        sx={{
                            backgroundColor: !false?'#A9A9A9 !important':'primary.main',
                            color: 'white !important',
                            margin: '8px 18px 8px 9px',
                            alignItems:"bottom",
                            padding:"10px 100px"
                        }}
                        // onClick={()=>handleCreate()}
                        >
                            Confirm
                        </FooterButton>
                    </FooterButtonContainer>
                </Box>
                </Box>
            </FooterFixedRoot>
        </>
    )
}